import { ModalProps, withModalConditionalRender } from '@billy/design-system'
import { ReactElement } from 'react'

import { CompanyInformationFormProvider } from './contexts/companyInformationFormContext'
import { CompanyInformationModalComponent } from './elements/CompanyInformationModalComponent'

interface CompanyInformationModalProps extends ModalProps {
  onSubmit?: () => void
}

const CompanyInformation = ({ onSubmit, ...modalProps }: CompanyInformationModalProps): ReactElement => {
  return (
    <CompanyInformationFormProvider onSubmit={onSubmit}>
      <CompanyInformationModalComponent {...modalProps} />
    </CompanyInformationFormProvider>
  )
}

export const CompanyInformationModal = withModalConditionalRender(CompanyInformation)
